// passes all the data to the respected components

import React from 'react';

import BlogAuthorPanel from './BlogAuthorPanel';
import BlogBreadcrumbsContainer from './BlogBreadcrumbs/index';
import FormContainerWImage from './FormContainerWImage';
import BlogContentRendering from './BlogContentRendering';
import BlogDetailMastheadContainer from './BlogDetailMasthead';
import BlogReferences from './BlogReferences';
import BlogScrollContainer from './BlogScroll/index';
import CampaignMasthead from './CampaignMasthead/index';
import SaunaComparisonChart from './SaunaComparisonChart';
import ColorPanel from './ColorPanel';
import ContentExplorer from './ContentExplorer';
import ColumnizedContent from './ColumnizedContent';
import ContactUsPanel from './ContactUsPanel';
import CountrySelectOverlay from './CountrySelectOverlay';
import CtaBar from './CtaBar';
import CtaContainer from './CtaContainer';
import FeatureShowcaseSlider from './FeatureShowcaseSlider';
import DiscountBanner from './DiscountBanner';
import FilteredContentContainer from './FilteredContent';
import GeneralJotform from './GeneralJotForm';
import GlobalMasthead from './GlobalMasthead';
import FormMasthead from './FormMasthead';
import GlobalOffices from './GlobalOffices';
import GuidesAndManualsContainer from './GuidesAndManuals';
import Headline from './Headline';
import HighlightedContentBlock from './HighlightedContentBlock';
import ImageWithCopySlider from './ImageWithCopySlider';
import LogoGarden from './LogoGarden';
import ImageCopyBlock from './ImageCopyBlock';
import ImageGallery from './ImageGallery';
import ImageWithCta from './ImageWithCta';
import ImageWithStatementBlock from './ImageWithStatementBlock';
import JumpToTopic from './JumpToTopic';
import NumberedPanel from './Numbered Panel';
import OnPageSupportSearchContainer from './OnPageSupportSearch';
import OneTrustCookieButton from './OneTrustCookieButton';
import OneTrustCookieList from './OneTrustCookieList';
import Pdf from './Pdf';
import PageRelevancyTagsContainer from './PageRelevancyTags';
import PartnerTestimonials from './TestimonialScroll';
import ProductComparison from './ProductComparison';
import ProductDescription from './ProductDescription';
import ProductDetailHighlight from './ProductDetailHighlight/ProductDetailHighlight';
import ProductDetailMastheadContainer from './ProductDetailMasthead';
import ProductFamilyCarouselContainer from './ProductFamilyCarousel/index';
import ProductSideBySideContainer from './ProductSideBySide';
import ProductSpecifications from './ProductSpecifications';
import ProductSupportLayoutContainer from './ProductSupportLayout';
import ProductTour from './ProductTour';
import ProductTourWDescription from './ProductTourWDescription';
import ProductVariants from './ProductVariants';
import PromotedContentStyleB from './PromotedContentStyleB';
import PromotedContentStyleC from './PromotedContentStyleC';
import PromotionalDiscountOverlay from './PromotionalDiscountOverlay';
import PromotionalStyleA from './PromotionalstylesA';
import QuotedText from './QuotedText';
import RelatedProductsContainer from './RelatedProducts/index';
import RteComponent from './RteComponent';
import ShopPanelWithInsetImage from './ShopPanelWithInsetImage';
import StatementBlockWithIconOption from './StatementBlockWithIconOption';
import SupportContactPanel from './SupportContactPanel';
import SupportMasthead from './SupportMasthead';
import SupportSearchResultsContainer from './SupportSearchResults';
import TileCarouselContainer from './TileCarouselContainer';
import TopicCallOut from './TopicCallOut';
import TrustPilot from './TrustPilot';
import IFrame from './IFrame';
import Sitemap from './Sitemap';
import ComparisonChart from './ComparisonChart';
import VideoHighlight from './VideoHighlight';
import WhatSaunaContainer from './WhatSaunaIsRightForYouForm';
import WhatSaunaIsRightForYouEnhanced from './WhatSaunaIsRightForYouEnhanced';
import SaunaQuizResults from './SaunaQuizResults';

import ProductShowcase from './ProductShowcase';
import ProductDisplayCardsGallery from './ProductDisplayCardsGallery';
import ConsultantTestimonial from './ConsultantTestimonial';
import ContentIllustration from './ContentIllustration';
import CustomerTestimonial from './CustomerTestimonial';

const Components = {
    component___author: BlogAuthorPanel,
    component___basic_image_gallery: ImageGallery,
    component___blog_breadcrumb: BlogBreadcrumbsContainer,
    component___blog_content: BlogContentRendering,
    component___form_container_w__image: FormContainerWImage,
    component___blog_masthead: BlogDetailMastheadContainer,
    component___blog_references: BlogReferences,
    component___blog_scroll: BlogScrollContainer,
    component___campaign_masthead: CampaignMasthead,
    component___sauna_comparison_chart: SaunaComparisonChart,
    component___color_panel: ColorPanel,
    component___columnized_content: ColumnizedContent,
    component___contact_panel: ContactUsPanel,
    component___content_explorer: ContentExplorer,
    component___country_select_overlay: CountrySelectOverlay,
    component___cta_bar: CtaBar,
    component___cta_container: CtaContainer,
    component___discount_banner: DiscountBanner,
    component___feature_showcase_slider: FeatureShowcaseSlider,
    component___filtered_content: FilteredContentContainer,
    component___form_container: GeneralJotform,
    component___global_maps_and_cards: GlobalOffices,
    component___guides_and_manuals: GuidesAndManualsContainer,
    component___half_image_copy_block_a9f8fc6: ImageCopyBlock,
    component___headline: Headline,
    component___highlight_content_block: HighlightedContentBlock,
    component___image_with_copy_slider: ImageWithCopySlider,
    component___logo_garden: LogoGarden,
    component___image_with_cta: ImageWithCta,
    component___image_with_statement_block: ImageWithStatementBlock,
    component___jump_to_topic: JumpToTopic,
    component___numbered_panels: NumberedPanel,
    component___on_page_support_search: OnPageSupportSearchContainer,
    component___onetrust_cookie_button: OneTrustCookieButton,
    component___onetrust_cookie_list: OneTrustCookieList,
    component___page_relevancy_tags: PageRelevancyTagsContainer,
    component___partner_testimonials: PartnerTestimonials,
    component___pdf_asset: Pdf,
    component___product_comparison: ProductComparison,
    component___product_description: ProductDescription,
    component___product_detail_highlight: ProductDetailHighlight,
    component___product_detail_masthead: ProductDetailMastheadContainer,
    component___product_family_carousel: ProductFamilyCarouselContainer,
    component___product_side_by_side: ProductSideBySideContainer,
    component___product_specifications: ProductSpecifications,
    component___product_support_layout: ProductSupportLayoutContainer,
    component___product_tour: ProductTour,
    component___product_tour_w__description: ProductTourWDescription,
    component___product_variants: ProductVariants,
    component___promotion_discount_overlay: PromotionalDiscountOverlay,
    component___promotional_style_a: PromotionalStyleA,
    component___promotional_style_b: PromotedContentStyleB,
    component___promotional_style_c: PromotedContentStyleC,
    component___quoted_text: QuotedText,
    component___related_products: RelatedProductsContainer,
    component___rte: RteComponent,
    component___shop_panel_with_inset_image: ShopPanelWithInsetImage,
    component___statement_block_with_icon_option: StatementBlockWithIconOption,
    component___support_contact_panel: SupportContactPanel,
    component___support_masthead: SupportMasthead,
    component___support_search: SupportSearchResultsContainer,
    component___tile_carousel__container_: TileCarouselContainer,
    component___topic_call_outs: TopicCallOut,
    component___trust_pilot_reviews: TrustPilot,
    component___iframe: IFrame,
    component___sitemap: Sitemap,
    component___brand_comparison_chart: ComparisonChart,
    component___what_sauna_is_right_for_you: WhatSaunaContainer,
    component___global_masthead: GlobalMasthead,
    component___form_masthead: FormMasthead,
    component___what_sauna_is_right_for_you__copy_:
        WhatSaunaIsRightForYouEnhanced,
    component___sauna_quiz_results: SaunaQuizResults,
    component___product_showcase: ProductShowcase,
    component___product_display: ProductDisplayCardsGallery,
    component___consultant_testimonial: ConsultantTestimonial,
    component___content_illustration: ContentIllustration,
    component___customer_testimonials: CustomerTestimonial,
    component___video_highlight: VideoHighlight,
};

const REMOVED_TESTIMONIALS_TO_ITEM_ID = '8836d056-9fd9-4243-8fef-dfd0c06b1320';

const ReferenceComponent = ({
    name,
    kontentItemId,
    ...props
}: {
    name: string;
    kontentItemId?: string;
    [key: string]: any;
}) => {
    // "Customer Testimonials - Testimonials.to" iframe embed
    // (customer_testimonials___testimonials_to) is intentionally not rendered.
    if (kontentItemId === REMOVED_TESTIMONIALS_TO_ITEM_ID) {
        return null;
    }
    //@ts-ignore
    let Component = Components[name];
    if (!Component) {
        return null;
    }

    return <Component kontentItemId={kontentItemId} {...props} />;
};

export default ReferenceComponent;
